import script from "./DocumentsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentsForm.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentsForm.vue?vue&type=style&index=0&id=28dc1cc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28dc1cc4"]])

export default __exports__